import { Pipe, PipeTransform } from '@angular/core';
import { WHITE_SPACE } from '../constants';

@Pipe({
  name: 'formattedThousands'
})
export class FormattedThousandsPipe implements PipeTransform {

  transform(value: any, isFractional: boolean = true): any {
    if (value) {
      var parts = value.toString().replace(WHITE_SPACE, "").replace(',', '.').split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      if (!isFractional) {
        return parts[0];
      }

      let formattedValue = parts.join(",");
      if (formattedValue.indexOf(',') === -1) {
        formattedValue += ',00';
      }

      return formattedValue;
    }

    return value;
  }

}
